module.exports = __webpack_public_path__ + "static/media/icon-paper.69a8c2e9.svg";